// since we are loading user data on the client side
// we need a way to get these elements after client side load
// we use a method to get these elements to ensure they exist
const elements = {
    footer: {
        getContactCartId: () => document.getElementsByClassName('assets-site-footer__contact-cart-id')[0] || {},
        getSalesEngineerImage: () => document.getElementsByClassName('assets-site-footer__contact-se-img')[0] || {},
        getContactMethods: () => document.getElementsByClassName('site-footer-contact__methods')[0] || {},
        getContactForm: () => document.getElementById('siteContactForm') || {}
    },
    header: {
        getHeaderWrap: () => document.getElementById('assets-header') || {},
        getSearchWrap: () => document.querySelector('.assets-site-header__menu-search-wrap'),
        getBackWrap: () => document.getElementsByClassName('assets-site-header__menu-back-wrap')[0] || {},
        searchInput: {
            desktop: () => document.getElementById('sw-search-input') || {},
            mobile: () => document.getElementById('sw-search-input-mobile') || {},
        },
        getCartCount: () => document.getElementsByClassName('assets-site-header__menu-cart-count')[0] || {},
        getCartLabel: () => document.getElementsByClassName('assets-site-header__menu-cart-wrap')[0] || {},
        getCartIcon: () => document.getElementsByClassName('assets-site-header__menu-cart-icon')[0] || {},
        getCartIconContainer: () => document.getElementById('assets-cart-icon-container') || {},
        getContactCartIdOne: () => document.getElementsByClassName('assets-site-header__nav-menu-contact-cart-id')[0] || {},
        getContactCartIdTwo: () => document.getElementsByClassName('assets-site-header__nav-menu-contact-cart-id')[1] || {},
        getLoggedInAccDivOne: () => document.getElementsByClassName('assets-site-header__nav-menu-account-logged-in')[0] || {},
        getLoggedInAccDivTwo: () => document.getElementsByClassName('assets-site-header__nav-menu-account-logged-in')[1] || {},
        getLoggedInWishlistDivOne: () => document.getElementsByClassName('assets-site-header__nav-menu-account-logged-in-wishlist')[0] || {},
        getLoggedInWishlistDivTwo: () => document.getElementsByClassName('assets-site-header__nav-menu-account-logged-in-wishlist')[1] || {},
        getLoggedOutAccDivOne: () => document.getElementsByClassName('assets-site-header__nav-menu-account-logged-out')[0] || {},
        getLoggedOutAccDivTwo: () => document.getElementsByClassName('assets-site-header__nav-menu-account-logged-out')[1] || {},
        getSalesEngineerImages: () => document.querySelectorAll('.assets-site-header__nav-menu-contact-se-img') || [],
        getTelephoneNumber: () => document.getElementsByClassName('assets-site-header__menu-telephone')[0] || {},
        getLogInPrompt: () => document.querySelector('.log-in-prompt') || {},
    },
};

export default elements;
